module.exports = __webpack_public_path__ + "static/media/three.8efc513c.ogg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/three.ogg
// module id = 129
// module chunks = 0